/**
 *
 * RoutesAlert
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { compose } from 'redux';
import { ControlAlert } from 'components/AlertList';
import { FormattedMessage } from 'react-intl';

import withRoutes from 'containers/Routes/withEntity';
import withUiControl from 'containers/UiControl/withUiControl';
import messages from './messages';

/* eslint-disable react/prefer-stateless-function */
function RoutesAlert(props) {
  const { routes, showRoutes } = props;
  const plus100 = routes.list && routes.list.length >= 100;
  if (!showRoutes || !plus100) {
    return null;
  }
  return (
    <ControlAlert bsStyle="warning">
      <FormattedMessage {...messages.onlyLatest} />
    </ControlAlert>
  );
}

RoutesAlert.propTypes = {
  routes: PropTypes.object,
  showRoutes: PropTypes.bool,
};

export default compose(
  withRoutes,
  withUiControl('showRoutes'),
)(RoutesAlert);
